import React from 'react';
import { View } from './view';
import { StatelessView } from './viewStateless';
import { ISmartProps } from './types';

export type AccordionProps = Omit<ISmartProps, 'css'>;

export const Accordion = View;
export const StatelessAccordion = StatelessView;
